export const ShowToast = (message, type = "primary") => {
  const alertDiv = document.createElement("div");
  alertDiv.className = `alert alert-${type} alert-dismissible cookies-alert position-fixed top-0 end-0 m-3 shadow`;
  alertDiv.setAttribute("role", "alert");
  alertDiv.style.zIndex = 2000;

  alertDiv.innerHTML = `
          <div class="d-flex justify-content-between align-items-center">
            <img alt="icon" class="w-35 h-35 me-2" src="../assets/images/icons/cookie-.png" />
            <p class="mb-0 flex-grow-1">${message}</p>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
        `;

  document.body.appendChild(alertDiv);

  // Auto remove after 3s
  setTimeout(() => {
    if (alertDiv) alertDiv.remove();
  }, 3000);
};

export default ShowToast;
